import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { ViewTrendData } from '../../../services/analyticsApi';
import './TrendChart.css';

interface TrendChartProps {
  data: ViewTrendData[];
}

const TrendChart: React.FC<TrendChartProps> = ({ data }) => {
  const formatXAxisLabel = (label: string) => {
    const date = new Date(label);
    return `${date.getMonth() + 1}/${date.getDate()}`;
  };

  return (
    <div className="trend-chart">
      <h3 className="trend-chart__title">瀏覽量趨勢</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis
            dataKey="date"
            tickFormatter={formatXAxisLabel}
            stroke="#666"
            fontSize={12}
          />
          <YAxis stroke="#666" fontSize={12} />
          <Tooltip
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '4px',
            }}
          />
          <Line
            type="monotone"
            dataKey="views"
            stroke="#d4af37"
            strokeWidth={2}
            dot={{ fill: '#d4af37', r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrendChart;
